const CARTO_BASEMAP_KEY = String(process.env.REACT_APP_CARTO_BASEMAP_KEY || '').trim();

const withCartoKey = (url) => {
  if (!CARTO_BASEMAP_KEY) return url;
  const joiner = url.includes('?') ? '&' : '?';
  return `${url}${joiner}key=${encodeURIComponent(CARTO_BASEMAP_KEY)}`;
};

const buildRasterStyle = (name, tiles, attribution) => ({
  version: 8,
  name,
  sources: {
    rasterTiles: {
      type: 'raster',
      tiles,
      tileSize: 256,
      attribution,
    },
  },
  layers: [
    {
      id: 'raster-layer',
      type: 'raster',
      source: 'rasterTiles',
      minzoom: 0,
      maxzoom: 22,
    },
  ],
});

export const MAP_PROVIDER_OPTIONS = [
  {
    key: 'osm-standard',
    label: 'OpenStreetMap',
    style: buildRasterStyle(
      'OSM Standard',
      ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
      '&copy; OpenStreetMap contributors',
    ),
  },
  {
    key: 'carto-voyager',
    label: 'Carto Voyager',
    style: buildRasterStyle(
      'Carto Voyager',
      [withCartoKey('https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}.png')],
      '&copy; OpenStreetMap contributors &copy; CARTO',
    ),
  },
  {
    key: 'carto-dark',
    label: 'Carto Dark Matter',
    style: buildRasterStyle(
      'Carto Dark',
      [withCartoKey('https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png')],
      '&copy; OpenStreetMap contributors &copy; CARTO',
    ),
  },
  {
    key: 'open-topo',
    label: 'OpenTopoMap',
    style: buildRasterStyle(
      'OpenTopoMap',
      ['https://tile.opentopomap.org/{z}/{x}/{y}.png'],
      '&copy; OpenStreetMap contributors, SRTM | Map style: OpenTopoMap',
    ),
  },
  {
    key: 'esri-satellite',
    label: 'Esri Satellite',
    style: buildRasterStyle(
      'Esri Satellite',
      ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
      'Tiles &copy; Esri',
    ),
  },
];

export const DEFAULT_MAP_PROVIDER_KEY = MAP_PROVIDER_OPTIONS[0].key;

export const resolveMapStyleByKey = (providerKey) => {
  return (
    MAP_PROVIDER_OPTIONS.find((option) => option.key === providerKey)?.style
    || MAP_PROVIDER_OPTIONS[0].style
  );
};
